import { render, staticRenderFns } from "./UserInfoItem.vue?vue&type=template&id=4e5e88eb&"
import script from "./UserInfoItem.vue?vue&type=script&lang=js&"
export * from "./UserInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports